import React from "react";
import { Link } from "react-router-dom";
import Icon from "../icons/Icons";
import { openCalendly } from "../../lib/calendly";
import "./CtaBand.css";

const CtaBand = () => {
  return (
    <section className="section-tight">
      <div className="container">
        <div className="cta-band blueprint">
          <div className="cta-band-copy">
            <p className="eyebrow">next step</p>
            <h2 className="h2">Ready to transform your cloud infrastructure?</h2>
            <p className="lede">
              Book a free 30-minute consultation — we'll review your setup and
              show you exactly where you can save.
            </p>
          </div>
          <div className="cta-band-actions">
            <button className="btn btn-primary" onClick={openCalendly}>
              <Icon name="calendar" size={16} />
              Schedule free consultation
            </button>
            <Link to="/contact" className="btn btn-ghost">
              Contact us
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaBand;
